import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/37_card_back_japanese_scenery/37_card_back_japanese_scenery"
 * Contains 1 texture(s)
 */
export class CardsBacks37CardBackJapaneseSceneryAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/37_card_back_japanese_scenery/37_card_back_japanese_scenery';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '37_japanese_scenery.png'
    ] as const;
}
